import {useCurrencyDetail} from '@/hooks/catalog';
import {formatCurrency} from '@/lib/utils/giftCard.utils';
import {extractPriceDetails} from '@/lib/utils/price.utils';
import {useMessages} from '@epic-mw/i18n';
import {CatalogOffer} from 'epic-graphql-types';
import {isEmpty} from 'lodash';
import {memo} from 'react';

const CatalogPrice = (offer: CatalogOffer) => {
	const amount = offer.currentPrice || offer.basePrice;
	const detail = useCurrencyDetail(offer.currencyCode!);

	if (detail.isLoading || !detail?.currency || !amount) {
		return '-';
	}
	return (
		<>
			{formatCurrency(
				amount || 0,
				detail.currency.code!,
				offer.locale!,
				detail.currency.decimals!
			)}
		</>
	);
};

const CatalogFree = memo(() => {
	const messages = useMessages();
	return messages['epic.app.spend.price.free'];
});

export const useCatalogPriceEngine = (offer: CatalogOffer) => {
	if (!offer || isEmpty(offer)) {
		return null;
	}

	const {priceDisplay, isFree} = extractPriceDetails(offer.price!);

	if (isFree) {
		return <CatalogFree />;
	}

	if (!priceDisplay) {
		return <CatalogPrice {...offer} />;
	}

	return <>{priceDisplay}</>;
};
